import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  Button,
  Stack,
  CircularProgress,
  Avatar,
  
} from "@mui/material";
import { FilterList, Clear, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { useGetFeedbackQuery } from "../../redux/Slices/feedbackApi";
import FeedbackDetailsModal from "./FeedbackDetailsModel";
import RTLDataGrid from "../../components/styled-component/RTLDataGrid";
import MDBox from "components/MDBox";

const FeedbackAdmin = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  // Filters
  const [filters, setFilters] = useState({
    status: "",
    priority: "",
    sort_by: "created_at",
    sort_order: "desc",
  });



  const params = {
    page: page + 1,
    per_page: rowsPerPage,
    status: filters.status,
    priority: filters.priority,
    sort_by: filters.sort_by,
    sort_order: filters.sort_order,
  };

  const { data: feedbackData, isLoading: isLoadingFeedback } = useGetFeedbackQuery(
    new URLSearchParams(params).toString()
  );

  useEffect(() => {
    if (feedbackData?.meta?.total) {
      setTotalCount(feedbackData.meta.total);
    }
  }, [feedbackData]);


  // get all feedbacks with filters by Priority , status ,sort_by and sort_order
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
    setPage(0);
  };

  const handleClearFilters = () => {
    setFilters({
      status: "",
      priority: "",
      sort_by: "created_at",
      sort_order: "desc",
    });
    setPage(0);
  };

  const getStatusColor = (status) => {
    const colors = {
      new: "error",
      in_progress: "warning",
      resolved: "success",
      closed: "default",
    };
    return colors[status] || "default";
  };

  const getStatusLabel = (status) => {
    const labels = {
      new: "جديد",
      in_progress: "قيد المعالجة",
      resolved: "تم الحل",
      closed: "مغلق",
    };
    return labels[status] || status;
  };

  const getPriorityColor = (priority) => {
    const colors = {
      high: "error",
      medium: "primary",
      low: "info",
    };
    return colors[priority] || "default";
  };

  const getPriorityLabel = (priority) => {
    const labels = {
      high: "عالية",
      medium: "متوسطة",
      low: "منخفضة",
    };
    return labels[priority] || priority;
  };

  return (
    <>
      <MDBox dir={"rtl"} sx={{ p: 3, minHeight: "100vh" }}>
        <Card sx={{ mb: 3 }}>
        {/* Header */}
        <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    borderRadius="lg"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                      boxShadow: 3,
                    }}
                  > 
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            إدارة الشكاوى والملاحظات
          </Typography>
        </MDBox>

        {/* Filters Card */}
        
          <CardContent sx={{ display: "flex", alignItems: "center", my:2}}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <FilterList sx={{ mr: 1 ,color:"text.main" }} />
              
            </Box>

            <Grid container spacing={2} flex={1}>
              <Grid item size={{ xs: 12, md:3 }}>
                <FormControl
                  fullWidth
                  size="large"
                  sx={{
                   
                   height: "45px",
                   "& .MuiSelect-select:focus": {
                    borderColor:"text.main"
                   },
                  }}
                >
                  <InputLabel id="status-label"
                               
                  >الحالة</InputLabel>
                  <Select
                    labelId="status-label"
                    sx={{
                      height: "100%",
                     "& .MuiSelect-select:focus": {
                      borderColor:"text.main"
                     },
                    }}
                    id="status"
                    value={filters.status}
                    label="الحالة"
                    onChange={(e) => handleFilterChange("status", e.target.value)}
                  >
                    <MenuItem value="">الكل</MenuItem>
                    <MenuItem value="new">جديد</MenuItem>
                    <MenuItem value="in_progress">قيد المعالجة</MenuItem>
                    <MenuItem value="resolved">تم الحل</MenuItem>
                    <MenuItem value="closed">مغلق</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item size={{ xs: 12, md:3 }}>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    height: "45px",
                    "& .MuiSelect-select:focus": {
                      outlineColor:"text.main"
                     },
                  }}
                >
                  <InputLabel>الأولوية</InputLabel>
                  <Select
                  sx={{
                    height: "100%",
                   "& .MuiSelect-select:focus": {
                    outlineColor:"text.main"
                   },
                  }}
                    value={filters.priority}
                    label="الأولوية"
                    onChange={(e) => handleFilterChange("priority", e.target.value)}
                  >
                    <MenuItem value="">الكل</MenuItem>
                    <MenuItem value="high">عالية</MenuItem>
                    <MenuItem value="medium">متوسطة</MenuItem>
                    <MenuItem value="low">منخفضة</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item size={{ xs: 12, md: 3 }}>
                <FormControl fullWidth size="small" sx={{
                  height: "45px",
                  "& .MuiSelect-select:focus": {
                    outlineColor:"text.main"
                   },
                }}>
                  <InputLabel>الترتيب حسب</InputLabel>
                  <Select
                  sx={{
                    height: "100%",
                   "& .MuiSelect-select:focus": {
                    outlineColor:"text.main"
                   },
                  }}
                    value={filters.sort_by}
                    label="الترتيب حسب"
                    onChange={(e) => handleFilterChange("sort_by", e.target.value)}
                  >
                    <MenuItem value="created_at">تاريخ الإنشاء</MenuItem>
                    <MenuItem value="priority">الأولوية</MenuItem>
                    <MenuItem value="status">الحالة</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Stack direction="row" display={{ xs: "none", md: "flex" }} spacing={1} justifyContent="space-between">
                  <Button
                    variant="outlined"
                    size="small"
                    color="divider"
                    fullWidth
                    startIcon={filters.sort_order === "asc" ? <ArrowUpward /> : <ArrowDownward />}
                    onClick={() =>
                      handleFilterChange(
                        "sort_order",
                        filters.sort_order === "asc" ? "desc" : "asc"
                      )
                    }
                  >
                    {filters.sort_order === "asc" ? "تصاعدي" : "تنازلي"}
                  </Button>
                  <IconButton
                    color="text.main"
                    onClick={handleClearFilters}
                    sx={{  color: "text.main" ,"&:hover": { borderColor: "none" ,bgcolor: "error.main" ,color: "text.main" }, mr: "auto" }}
                  >
                    <Clear />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Feedbacks Table */}
        <Card>
          
            {isLoadingFeedback ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                  <RTLDataGrid
                    rows={feedbackData?.data || []}
                    rowCount={totalCount}
                    paginationMode="server"
                    paginationModel={{ page, pageSize: rowsPerPage }}
                    onPaginationModelChange={(model) => {
                      setPage(model.page);
                      setRowsPerPage(model.pageSize);
                    }}
                    columns={[
                      {
                        field: "user",
                        headerName: "المستخدم",
                        flex: 1,
                        renderCell: (params) => (
                          <Box sx={{ display: "flex", alignItems: "center",  gap: 1 }}>
                            <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
                              {params.value?.name?.charAt(0)}
                            </Avatar>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {params.value?.name}
                              </Typography>
                              <Typography variant="caption" color="text.main">
                                {params.value?.email}
                              </Typography>
                            </Box>
                          </Box>
                        ),
                      },
                      {
                        field: "title",
                        headerName: "العنوان",
                        flex: 1,
                        renderCell: (params) => (
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {params.row.title}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.main"
                              sx={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}
                            >
                              {params.row.description}
                            </Typography>
                          </Box>
                        ),
                      },
                      {
                        field: "feedback_type",
                        headerName: "النوع",
                        flex: .5,
                        renderCell: (params) => (
                          <Chip
                            label={params.value?.name}
                            size="small"
                            variant="outlined"
                            sx={{
                              color:"text.main",
                              p:2,
                            }}
                          />
                        ),
                      },
                      {
                        field: "status",
                        headerName: "الحالة",
                        flex: .5,
                        renderCell: (params) => (
                          <Chip
                            label={getStatusLabel(params.value)}
                            color={getStatusColor(params.value)}
                            size="small"
                            variant="outlined"
                            sx={{
                              color:"text.main",
                              p:2,
                            }}
                          />
                        ),
                      },
                      {
                        field: "priority",
                        headerName: "الأولوية",
                        flex: .5,
                        renderCell: (params) => (
                          <Chip
                            label={getPriorityLabel(params.value)}
                            color={getPriorityColor(params.value)}
                            size="small"
                            variant="outlined"
                            sx={{
                              color:"text.main",
                              p:2,
                            }}
                          />
                        ),
                      },
                      {
                        field: "created_at",
                        headerName: "التاريخ",
                        flex: .5,
                        renderCell: (params) => (
                          <Typography variant="caption">{params.value}</Typography>
                        ),
                      },
                    ]}
                    onShow={(row) => {
                      setSelectedFeedback(row);
                      setOpenModal(true);
                    }}
                  />
              </>
            )}
          
        </Card>
      </MDBox>

      <FeedbackDetailsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        feedback={selectedFeedback}
      />
    </>
  );
};

export default FeedbackAdmin;
